type InputRadioButtonProps = {
    title?:string,
    options:optionSet[],
    onChange: (value) => void,
    required?:boolean,
    multiSelect?:boolean,
    testId?:string,
}

export type optionSet = {
    name:string,
    value: any,
    selected:boolean
}

export function InputRadioButton (props:InputRadioButtonProps) {
        return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-start' }} data-testid={props.testId}>
                    {props.title ? (
                        <label className="label" style={{ marginBottom: 0 }}>
                            {props.title} {props.required && <span className="required-dot" aria-label="required">*</span>}
                        </label>
                    ) : null}
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 0 }}>
                            {props.options.map((o, idx) =>(
                                    <button key={`id_${idx}`} className={"groupedOption " + (o.selected ? "selected" : "")} style={{ }} onClick={() => props.onChange(o.value)} data-testid={props.testId ? `${props.testId}-option-${String(o.value)}` : undefined} data-selected={o.selected}>{o.name}</button>
                            ))}
                    </div>
                </div>
        )
}
